import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Divider,
  useTheme,
  styled,
  useMediaQuery,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Avatar,
} from '@mui/material';
import Typography from '../../../common/Utility/Typography';
import { variants } from '../../../variants/variants';
import { announcementNavigationMobile, navigations } from '../utility/navigations';
import UserAvatar from '../../../common/UserAvatar';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentUser,
  selectCurrentUserStatus,
  selectDeviceType,
  selectUserSatuses,
  selectUserStatus,
  setLayout,
} from '../../Auth/authSlice';
import { AdminPanelSettingsOutlined, ExitToAppOutlined, MoreVert } from '@mui/icons-material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFetchProfileQuery, useGetUserStatusQuery } from '../../Profile/profileApiSlice';
import { useLogoutMutation, useRemoveFcmTokenMutation } from '../../Auth/authApiSlice';
import { clearAuth } from '../../Auth/Utility/ClearAuth';
import { Can } from '../../../context/Ability';
import useSocket from '../../../hooks/sockets/useSocket';
import { statusOptions } from '../../../constants/statusOptions';
import SkeletonProfileActions from '../skeletons/SkeletonProfileActions';
import { webview } from '../../../app/api/webview';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { border } from '@mui/system';
import gatewayLogo from '../../../assets/GatewayLogo/image.png';
import { use } from 'react';
import { fontWeight } from '@mui/system';
import { textAlign } from '@mui/system';
import { width } from '@mui/system';
import gatewaybackgroundlogo from '../../../assets/GatewayLogo/imageGateway.png';
import IdCardDialog from './IdCardDialog';
const ProfileActions = ({ staff = false, handleNavClick, handleProfileClick, handleAnnouncementClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { pathname } = useLocation();
  const path = isMobile ? pathname.split('/')[3] : pathname.split('/')[2];
  const active = pathname.split('/')[3];
  const user = useSelector(selectCurrentUser);
  const [logout] = useLogoutMutation();
  const [removeFCMToken] = useRemoveFcmTokenMutation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: initialStatus } = useGetUserStatusQuery(user.empCode);
  const userStatus = useSelector(selectCurrentUserStatus);
  const { updateStatus } = useSocket(user.empCode, initialStatus);
  const userStatuses = useSelector(selectUserSatuses);
  const navigationArray = isMobile ? announcementNavigationMobile : navigations;
  const [dialog, setDialog] = useState(false);
  const [idCardDialog, setIdCardDialog] = useState(false);
  const deviceType = useSelector(selectDeviceType);

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };

  const handleLogout = async () => {
    await removeFCMToken({ empId: user.empId, deviceType }).unwrap();
    logout();
    clearAuth(dispatch);
    handleClose();
    navigate('/auth');
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleStatusChange = (status) => {
    updateStatus(status);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleFeedbackClick = () => {
    handleCloseMenu();
    navigate('/home/feedback');
  };

  const handleAdminClick = () => {
    dispatch(setLayout('admin'));
    navigate('/admin');
  };

  const handleViewIDCard = () => {
    setIdCardDialog(!idCardDialog);
  };

  const { data: userProfile, isLoading, error } = useFetchProfileQuery(user?.empCode);

  if (isLoading) return <SkeletonProfileActions />;
  if (error) return <div>Error loading profile</div>;

  return (
    <Box
      component={Paper}
      elevation={0}
      sx={{
        backgroundColor: variants.boxBackground.PROFILE_CARD,
        p: 0.5,
        borderRadius: variants.boxRadius.SIDEBAR,
        border: 1,
        borderColor: 'divider',
        position: 'relative',
      }}
    >
      {isMobile && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <UserAvatar
            empCode={user?.empCode}
            showStatus={true}
            size={35}
            src={userProfile?.employeePhotoPath}
            onClick={handleViewIDCard}
            sx={{ cursor: 'default', img: { objectFit: 'cover', objectPosition: 'top' } }}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: 48 * 4.5,
                width: '20ch',
              },
            }}
          >
            {statusOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={() => handleStatusChange(option.value)}
                selected={option.value === userStatus}
              >
                {option.label}
              </MenuItem>
            ))}
          </Menu>
          <Typography
            // onClick={() => {
            //   handleProfileClick(user?.empCode);
            // }}
            sx={{
              cursor: 'default',
              fontSize: variants.BODY,
              fontWeight: 600,
              ml: 1,
              color: '#0A4FAC',
            }}
            component={'div'}
          >
            {userProfile?.empName ||
              userProfile?.firstName + ' ' + userProfile?.middleName + ' ' + userProfile?.lastName}
            <Typography sx={{ fontSize: variants.TINY }} component={'div'}>
              Emp code : {userProfile?.empCode}
            </Typography>
          </Typography>
          <Box sx={{ ml: 'auto' }}>
            <IconButton size="small" onClick={handleMenuClick}>
              <Tooltip title="Menu">
                <MoreVert
                  sx={{ color: '#0A4FAC', transition: 'background-color 0.3s', '&:hover': { color: '#0056b3' } }}
                />
              </Tooltip>
            </IconButton>

            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleCloseMenu}
              PaperProps={{
                elevation: 3,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {!staff && (
                <>
                  <MenuItem onClick={() => handleFeedbackClick()}>
                    <FeedbackIcon
                      sx={{
                        mr: 1,
                        color: 'black',
                        fontSize: 18,
                      }}
                    />
                    <Typography variant="body2">Feedback</Typography>
                  </MenuItem>
                  <Divider />
                </>
              )}
              <MenuItem onClick={handleDialogOpen}>
                <ExitToAppOutlined
                  sx={{
                    mr: 1,
                    color: 'black',
                    fontSize: 18,
                  }}
                />
                <Typography variant="body2">Sign out</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          [theme.breakpoints.up('sm')]: {
            position: 'absolute',
            top: 4,
            right: 60,
            gap: 5,
          },
          [theme.breakpoints.up('md')]: {
            //backgroundColor: 'yellow',
            position: 'relative',
            top: 'inherit',
            right: 'inherit',
            gap: 0,
          },
        }}
      >
        {!staff &&
          navigationArray.map((nav, index) => {
            return (
              // <Can key={index} I={'read'} a={nav.feature}>
              <Box
                key={index}
                onClick={() => (isMobile ? handleAnnouncementClick(nav) : handleNavClick(nav))}
                sx={{
                  cursor: 'default',
                  mt: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  color: path == nav.path ? 'blue' : 'black',
                }}
              >
                <IconButton sx={{ p: 0, color: path == nav.path ? '#004BAE' : '#0f0f0f' }}>{nav.icon}</IconButton>
                <Typography sx={{ fontSize: variants.TINY, color: path == nav.path ? '#004BAE' : '#000' }}>
                  {nav.title}
                </Typography>
              </Box>
              // </Can>
            );
          })}
        {/* {isMobile && (
          <Can I="read" a="Admin">
            <Divider orientation="vertical" flexItem sx={{ mx: 0, height: '50px' }} />
            <Tooltip title="Admin Panel">
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                  mt:1
                }}
              >
                <Button
                  onClick={() =>
                    handleAnnouncementClick({ path: 'admin', title: 'Admin', icon: <AdminPanelSettingsOutlined /> })
                  }
                  disableRipple
                  sx={{ borderRadius: '50%', width: '1rem', height: '0.6rem' }}
                >
                  <AdminPanelSettingsOutlined
                    sx={{ fontSize: '1.5rem', color: active == 'admin' ? '#0A4FAC' : 'black' }}
                  />
                </Button>
                <Typography sx={{ fontSize: 12, color: active == 'admin' ? '#0A4FAC' : 'black' }}>Admin</Typography>
              </Grid>
            </Tooltip>
          </Can>
        )} */}
        <Dialog
          open={dialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Sign out'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">Are you sure you want to Sign out ?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>No</Button>
            <Button onClick={handleLogout} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <IdCardDialog
          open={idCardDialog}
          onClose={handleViewIDCard}
          logo={gatewayLogo}
          backgroundImage={gatewaybackgroundlogo}
          profileImage={userProfile?.employeePhotoPath}
          firstName={userProfile?.firstName}
          lastName={userProfile?.lastName}
          bloodGroup={user?.details?.travelData?.userDetails?.bloodGroup}
          emergencyContact={user?.details?.travelData?.userDetails?.emergencyContactNo}
          address={user?.details?.travelData?.userDetails?.permanentAddress}
        />
      </Box>
    </Box>
  );
};

export default ProfileActions;
